import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {bonusAccrualByBrand_template} from "./bonusAccrualByBrand_template";

declare var ko: any;

export class bonusAccrualClassificationByBrand_template extends vnTemplate{

    protected parent: bonusAccrualByBrand_template;

    protected getTemplateHtml(): string{

        return `
            <table class="list-action">
                <thead>
                    <tr>
                        <th class="align-center"><span data-bind="text: classification() "></span></th>
                        <th colspan="6" class="align-center"><span>h1</span></th>
                        <th colspan="6" class="align-center"><span>h2</span></th>
                    </tr>
                    <tr>
                        <td><span></span></td>
                        <!-- ko foreach: months -->
                            <th><span data-bind="text: name"></span></th>
                        <!-- /ko -->
                    </tr>
                </thead>
                <tbody id="list-action-body">
                    <tr>
                        <td><span> Inputted Accrual</span></td>
                        <!-- ko foreach: months -->
                        <td  class="align-right"> 
                            <div class="flex">                      
                                <input id="percentage" type="number" class="input-text" data-bind="value: percentage, enable: enable, valueUpdate: 'keyup', event:{ keyup: $parent.onChangeUpdate.bind($data)}">
                                <span>%</span>
                            </div>                         
                        </td>
                        <!-- /ko -->
                    </tr>
                    <tr>
                        <td><span> Accrual Amount USD </span></td>
                        <!-- ko foreach: months -->
                        <td class="align-right">
                            <div class="flex" style="justify-content: flex-end">
                                <span>$</span>   
                                <span data-bind="text: amount"></span>                                         
                            </div>                                   
                        </td>
                        <!-- /ko -->
                    </tr>
                    <tr>
                        <td><span> Scheduled/Paid </span></td>
                        <!-- ko foreach: months -->
                        <td class="align-right">
                            <div class="flex" style="justify-content: flex-end">
                                <span>$</span>   
                                <span data-bind="text: $parent.scheduledAndPaidCost()[id]"></span></td>
                            </div>
                        </td>
                        <!-- /ko -->
                    </tr>
                    <tr>
                        <td><span data-bind="text: totalEditorialClassificationBonusTitle() "></span></td>
                        <!-- ko foreach: months -->
                        <td class="align-right">
                            <div class="flex" style="justify-content: flex-end">
                                <span>$</span>   
                                <span data-bind="text: $parent.totalPerMonth()[id]"></span></td>
                            </div>
                        </td>
                        <!-- /ko -->
                    </tr>
                </tbody>
            </table>
            `;
    }

    protected initPartial(): void {

    }

    public setParent(parent: bonusAccrualByBrand_template): void {
        this.parent = parent;
    }

    protected getTemplateName(): string{
        return "bonusAccrualClassificationByBrand_template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["form-body","full-width"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            classification: ko.observable('Freelancers'),
            months: ko.observableArray(this.getMonths()),
            currentMonth: ko.observable(new Date().getMonth()+1),
            projectedCost: ko.observableArray([]),
            scheduledAndPaidCost: ko.observableArray([]),
            totalPerMonth: ko.observableArray([]),
            totalEditorialClassificationBonusTitle: ko.observable("P&L TOTAL EDITORIAL FREELANCE BONUS"),
            onChangeUpdate: (data, event) => { self.onChangeUpdate(); },
            onClickSave: (data, event) => { self.onClickSave(); },
            onClickCancel: (data, event) => { self.onClickCancel(); }
        };
    }

    public setClassification(classification: string): void {
        this.getTemplateViewModel().classification(classification);
    }

    public setTotalEditorialClassificationBonusTitle(totalEditorialClassificationBonusTitle: string): void {
        this.getTemplateViewModel().totalEditorialClassificationBonusTitle(totalEditorialClassificationBonusTitle);
    }

    public getClassification(): void {
        return this.getTemplateViewModel().classification();
    }
    public getViewModelForRequest() {

        return {
            filters: {
                idBrand: this.getTemplateViewModel().brandFilter.selectedOption,
                yearFilter: this.getTemplateViewModel().yearFilter.selectedOption
            }
        }
    }

    public getMonths(){
        return [
            { id : 1, name : 'January', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 2, name : 'February', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 3, name : 'March', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 4, name : 'April', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 5, name : 'May', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 6, name : 'June', percentage : 0, amount : ko.observable(0), enable: false },
            { id : 7, name : 'July', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 8, name : 'August', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 9, name : 'September', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 10, name : 'October', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 11, name : 'November', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 12, name : 'December', percentage : 0, amount : ko.observable(0), enable: false },
        ];
    }

    public getPostRequestData() {

        let monthsData = []
        let months = this.getTemplateViewModel().months();
        let selectedYear = this.parent.getSelectedYear();

        for( let month of months){
            let currentYear = new Date().getFullYear();
            let enable = true;
            if(month.id == 6 || month.id == 12 || (selectedYear == currentYear && month.id < this.getTemplateViewModel().currentMonth()) || (selectedYear < currentYear)) {
                enable = false;
            }
            let data = {
                id: month.id,
                name: month.name,
                percentage: month.percentage,
                amount: month.amount(),
                enable: enable
            };
            monthsData.push(data);
        }

        return  {
            months: monthsData,
            projectedCost: this.getTemplateViewModel().projectedCost(),
            scheduledAndPaidCost: this.getTemplateViewModel().scheduledAndPaidCost(),
            totalPerMonth: this.getTemplateViewModel().totalPerMonth()
        };
    }

    public setProjectedCost(value){

        this.getTemplateViewModel().projectedCost(value)
    }

    public setScheduledAndPaidCost(value){

        this.getTemplateViewModel().scheduledAndPaidCost(value)
    }

    public setTotalPerMonth(value){
        this.getTemplateViewModel().totalPerMonth(value);
    }

    public setMonths(months){

        this.getTemplateViewModel().months(months)
    }

    public onChangeUpdate(){

        this.updateAccrualAmounts();
    }

    public onClickSave(){

        this.caller.save();
    }

    public onClickCancel(){

        this.caller.cancel();
    }

    public updateList(bonusAccruals){

        let months = this.getMonths();
        let currentMonth = new Date().getMonth()+1;
        let currentYear = new Date().getFullYear();

        //update amount
        let totalAmount = 0;
        for( let i=0; i < bonusAccruals.length; i++){
            let month = (parseInt((bonusAccruals[i].yearAndMonth.split('-'))[1]) - 1);
            let amount = parseFloat(bonusAccruals[i].accrualAmount);

            months[month].percentage = bonusAccruals[i].inputedAccrualPercentage;

            months[month].amount( amount.toFixed(2));
        }

        let total = 0;
        months.forEach(function (value, i){

            if(i == 5 || i == 11){
                months[i].amount(-1 * total);
                total = 0;
            } else {
                total += parseFloat(value.amount());
            }
        })

        //update enable/disable field
        let selectedOption = this.parent.getSelectedYear();
        for( let i=0; i < months.length; i++) {
            if ((selectedOption == currentYear && months[i].id < currentMonth) || selectedOption < currentYear) {
                months[i].enable = false;
            }
        }

        this.getTemplateViewModel().months([]); //reset to update the non-observable percentage and enable fields
        this.getTemplateViewModel().months(months);
        let scheduledAndPaidCost = this.getTemplateViewModel().scheduledAndPaidCost();
        let totalPerMonth = [];
        months.forEach(function callback(value, index) {
            let idx = value.id;
            let amount = parseFloat(value.amount());
            let totalForMonth = parseFloat(scheduledAndPaidCost[idx]) + amount;
            totalPerMonth[idx] = totalForMonth.toFixed(2);
        });
        this.setTotalPerMonth(totalPerMonth);
    }

    protected updateAccrualAmounts(){

        let projectedCost = this.getTemplateViewModel().projectedCost();
        let months = this.getTemplateViewModel().months();
        for( let i=0; i < months.length; i++){

            if(months[i].percentage){
                let projectedCostAmount = 0;
                if(i < 6){
                    projectedCostAmount = projectedCost.h1;
                } else {
                    projectedCostAmount = projectedCost.h2;
                }

                let amount = projectedCostAmount * months[i].percentage / 100;
                if(months[i].enable) {
                    months[i].amount(amount.toFixed(2));
                }
            }else{
                months[i].amount(0);
            }
        }

        let total = 0;
        months.forEach(function (value, i){

            if(i == 5 || i == 11){
                months[i].amount((-1 * total).toFixed(2));
                total = 0;
            } else {
                total += parseFloat(value.amount());
            }
        });

        let scheduledAndPaidCost = this.getTemplateViewModel().scheduledAndPaidCost();
        let totalPerMonth = [];
        months.forEach(function callback(value, index) {
            let idx = value.id;
            let amount = parseFloat(value.amount());
            let totalForMonth = parseFloat(scheduledAndPaidCost[idx]) + amount;
            totalPerMonth[idx] = totalForMonth.toFixed(2);
        });
        this.setTotalPerMonth(totalPerMonth);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/bonusAccrualClassificationByBrand_template.ts